import { Badge, ScrollArea, Table, Text } from '@mantine/core';
import { BenchImportResult, BenchImportRowResult } from '../../services/benchImportService';

interface BenchImportResultTableProps {
    result: BenchImportResult;
}

const statusColor = (status: BenchImportRowResult['status']): string => {
    switch (status) {
        case 'Updated': return 'green';
        case 'Cleared': return 'blue';
        case 'AmbiguousName': return 'orange';
        case 'NotFound': return 'red';
        case 'NotPermitted': return 'orange';
        case 'NoIdentifier': return 'gray';
        case 'ParseError': return 'red';
        default: return 'gray';
    }
};

const statusLabel = (status: BenchImportRowResult['status']): string => {
    switch (status) {
        case 'Updated': return 'Updated';
        case 'Cleared': return 'Cleared';
        case 'AmbiguousName': return 'Ambiguous';
        case 'NotFound': return 'Not found';
        case 'NotPermitted': return 'Not permitted';
        case 'NoIdentifier': return 'No identifier';
        case 'ParseError': return 'Parse error';
        default: return status;
    }
};

export const BenchImportResultTable = ({ result }: BenchImportResultTableProps) => {
    const successCount = result.rows.filter(r => r.status === 'Updated' || r.status === 'Cleared').length;
    const errorCount = result.rows.length - successCount;

    return (
        <>
            <Text size="sm" c="dimmed">
                <strong>{successCount}</strong> rows processed successfully, <strong>{errorCount}</strong> with issues.
            </Text>
            <ScrollArea>
                <Table striped highlightOnHover withTableBorder withColumnBorders fz="sm">
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th w={60}>#</Table.Th>
                            <Table.Th>Person</Table.Th>
                            <Table.Th>Status</Table.Th>
                            <Table.Th>Detail</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {result.rows.map((row) => (
                            <Table.Tr key={row.rowNumber}>
                                <Table.Td>{row.rowNumber}</Table.Td>
                                <Table.Td>{row.identifier}</Table.Td>
                                <Table.Td>
                                    <Badge color={statusColor(row.status)} variant="light">
                                        {statusLabel(row.status)}
                                    </Badge>
                                </Table.Td>
                                <Table.Td>
                                    {row.detail}
                                    {row.matches && row.matches.length > 0 && (
                                        <Text size="xs" c="dimmed">{row.matches.join(', ')}</Text>
                                    )}
                                </Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </ScrollArea>
        </>
    );
};
